module.exports = __webpack_public_path__ + "static/media/YE.7ac63646.png";